import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';

dayjs.extend(relativeTime);

/**
 * `parkedAt` and `lastUpdatedAt` are INSTANTS (non_routable_request.created_timestamp /
 * modified_timestamp), not calendar dates — so unlike the Fill Later queue's scheduledFor they
 * are formatted in the viewer's own zone, with the time, because "how long has this been sitting
 * here" is the question this queue exists to answer.
 */
export const formatParkedAt = (value) => {
  if (!value) return 'N/A';
  const at = dayjs(value);
  return at.isValid() ? at.format('MM-DD-YYYY HH:mm') : 'N/A';
};

/** "3 days ago" — the age of a parked request is the triage signal, so it sits under the date. */
export const relativeParkedAt = (value, now = undefined) => {
  if (!value) return null;
  const at = dayjs(value);
  if (!at.isValid()) return null;
  return at.from(now ? dayjs(now) : dayjs());
};

/**
 * Filter dates come out of a date input as `YYYY-MM-DD`; the backend compares them against a
 * timestamp column, so an unqualified `parkedBefore` would silently exclude everything parked
 * during that day. Widen to the full local day at both ends and send ISO instants.
 */
export const startOfDayIso = (value) => {
  if (!value) return undefined;
  const at = dayjs(value);
  return at.isValid() ? at.startOf('day').toISOString() : undefined;
};

export const endOfDayIso = (value) => {
  if (!value) return undefined;
  const at = dayjs(value);
  return at.isValid() ? at.endOf('day').toISOString() : undefined;
};

/** Reverse of the two above, for rehydrating the date inputs from the stored ISO filter. */
export const isoToDateInput = (value) => {
  if (!value) return '';
  const at = dayjs(value);
  return at.isValid() ? at.format('YYYY-MM-DD') : '';
};
